import { render, staticRenderFns } from "./VideoRect.vue?vue&type=template&id=263a7c40&scoped=true&lang=pug&"
import script from "./VideoRect.vue?vue&type=script&lang=js&"
export * from "./VideoRect.vue?vue&type=script&lang=js&"
import style0 from "./VideoRect.scss?vue&type=style&index=0&id=263a7c40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263a7c40",
  null
  
)

export default component.exports